import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { Wordmark } from "@/components/brand/Logo";
import { api, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      navigate(data.is_admin ? "/admin" : "/admin/login", { replace: true });
      if (!data.is_admin) setError("Questo account non è autorizzato all'area admin");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  const inputCls = "w-full mt-2 px-4 py-3 bg-white border border-[#E6DFD5] text-sm outline-none focus:border-[#C5A059]";

  return (
    <div className="min-h-screen bg-[#F2ECE4] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="bg-[#FAF8F5] border border-[#E6DFD5] p-10 sm:p-14 w-full max-w-md">
        <div className="flex justify-center"><Wordmark height={110} /></div>
        <p className="fs-eyebrow mt-8 text-center">Area riservata</p>
        <h1 className="font-serif text-3xl mt-3 text-center">Beauty Advisor Admin</h1>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <label className="block text-xs tracking-[0.14em] uppercase text-[#8C8275]">Email
            <input data-testid="admin-email-input" type="email" required autoComplete="username" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} placeholder="amministrazione@…" />
          </label>
          <label className="block text-xs tracking-[0.14em] uppercase text-[#8C8275]">Password
            <input data-testid="admin-password-input" type="password" required autoComplete="current-password" value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} placeholder="••••••••" />
          </label>
          {error && <p data-testid="admin-login-error" className="text-sm text-[#A0482F]">{error}</p>}
          <button data-testid="admin-login-submit-btn" type="submit" disabled={busy} className="fs-btn w-full justify-center">
            <Lock size={14} strokeWidth={1.5} /> {busy ? "Accesso…" : "Accedi"} <ArrowRight size={16} strokeWidth={1.5} />
          </button>
        </form>
        <p className="text-[11px] text-[#8C8275] mt-6 text-center">Accesso riservato al team FineSkin Beauty.</p>
      </div>
    </div>
  );
}
